export default __webpack_public_path__ + "static/media/resetProfile.dea7d960.svg";